var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ecahrts",style:('width: 100%;'+(_vm.isMobile?'height:71vw':'height: 620px'))})
}
var staticRenderFns = []

export { render, staticRenderFns }